import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ServicePlanRateBO } from './serviceplanrate.model';
import { HttpClient } from '@angular/common/http';
import { GlobalComponent } from 'src/app/global/global.component';
import { ToastrService } from 'ngx-toastr';
import { CommonApiService } from 'src/app/commonapiservice';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-serviceplanrate',
  templateUrl: './serviceplanrate.component.html',
  styleUrls: ['./serviceplanrate.component.scss']
})
export class ServiceplanrateComponent implements OnInit {

  private onDestroy$: Subject<void> = new Subject<void>();
  subject: Subject<boolean>;
  touched: boolean = false;
  isSaveorUpdateBoolean: boolean = false;
  setting: ServicePlanRateBO = new ServicePlanRateBO();
  constructor( private CDR: ChangeDetectorRef,
    public http: HttpClient,
    public global: GlobalComponent,
    public toastrService: ToastrService,
    public CommonAPI: CommonApiService,

  ) { }
  ngOnInit() {
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0||this.global.globalAgencyId=='00000000-0000-0000-0000-000000000000') {
      return;
    }


    this.getAgencyServicePlanrate();

  }
  getAgencyServicePlanrate() {
    let url = "api/ServiceDeliveryPlan/GetServicePlanRate?";
    let myParams = new URLSearchParams();
    // myParams.append("AgencyId", this.global.globalAgencyId)
    let param = new URLSearchParams();
   
    this.CommonAPI.GetFunctionwithResponseTypeJson(param,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
   
       
        if(data!=null && data!=undefined && data!="")
        {
          this.setting = data;
        }
        else 
        {
          this.setting = new ServicePlanRateBO();
        }
      });
  }
  SaveOrUpdate() {
    this.isSaveorUpdateBoolean=true;
    var saveSettings: ServicePlanRateBO = JSON.parse(JSON.stringify(this.setting));
    saveSettings.normalRate = Number(saveSettings.normalRate)
    saveSettings.enhancedRate = Number(saveSettings.enhancedRate)
    saveSettings.ptoTax_Percent = Number(saveSettings.ptoTax_Percent)
    saveSettings.payrollTax_Percent = Number(saveSettings.payrollTax_Percent)
    let url = "api/ServiceDeliveryPlan/saveUpdatePlanRate?";

    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveSettings,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
 
      this.isSaveorUpdateBoolean=false;
          this.toastrService.success("Service Plan Rate configured successfully!"),
            8000;
        },
        (err: any) => {
          this.isSaveorUpdateBoolean=false;
          if (err) {
            this.toastrService.error(err.error, "Error"), 8000;
          }
        }
      );
  }
 
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  numberonly(event: any) {
    
    this.CDR.detach();
    setInterval(() => {
      this.CDR.detectChanges();
    }, 10);
    if (
      ((event.which < 48 &&
        event.which != 8 &&
        event.which != 46 &&
        event.which != 39 &&
        event.which != 37) ||
        event.which > 57) &&
      ((event.which < 96 &&
        event.which != 8 &&
        event.which != 46 &&
        event.which != 39 &&
        event.which != 37) ||
        event.which > 105)
    ) {
      event.preventDefault();
    }
    let text = "";
   
      text = event.target.innerHTML;
   
    text = text.trim ? text.trim() : text.replace(/^\s+/, "");
    
    if (text.length == 1) {
      if (text == "2") {
        if (event.key > 3) {
          event.preventDefault();
        }
      }
      if (parseInt(text) > 2) {
        if (event.which != 46) {
          event.preventDefault();
        }
      }
      if (text == ".") {
        if (
          !(
            event.which == 50 ||
            event.which == 53 ||
            event.which == 55 ||
            event.which == 48
          )
        ) {
          event.preventDefault();
        }
      }
    }
    // if (text.length == 2) {
    //   let array = text.split("");
    //   if (!(array[1] == ".")) {
    //     if (array[0] == ".") {
    //       if (array[1] == "5" || array[1] == "0") {
    //         if (!(event.which == 48)) {
    //        //   event.preventDefault();
    //         }
    //       }
    //       if (array[1] == "2" || array[1] == "7") {
    //         if (!(event.which == 53)) {
    //          // event.preventDefault();
    //         }
    //       }
    //     } else if (event.which != 46) {
    //       event.preventDefault();
    //     }
    //   } else {
    //     if (
    //       !(
    //         event.which == 50 ||
    //         event.which == 53 ||
    //         event.which == 55 ||
    //         event.which == 48
    //       )
    //     ) {
    //      // event.preventDefault();
    //     }
    //   }
    // }
    // if (text.length == 3) {
    //   let array = text.split("");
     
    //   if (array[0] == ".") {
    //     event.preventDefault();
    //   }
    //   if (array[2] == ".") {
    //     if (
    //       !(
    //         event.which == 50 ||
    //         event.which == 53 ||
    //         event.which == 55 ||
    //         event.which == 48
    //       )
    //     ) {
    //      // event.preventDefault();
    //     }
    //   }
    //   if (array[1] == ".") {
    //     let List = text.split(".");
      
    //     if (List[1] == "5" || List[1] == "0" || List[1] == "3") {
    //       if (!(event.which == 48)) {
    //       //  event.preventDefault();
    //       }
    //     }
    //     if (List[1] == "2" || List[1] == "7") {
    //       if (!(event.which == 53)) {
    //       //  event.preventDefault();
    //       }
    //     }
    //   }
    // }
    // if (text.length == 4) {
    //   let type = text.split(".");
    //   if (type[1].length == 2) {
    //   //  event.preventDefault();
    //   }
    //   if (type[1] == "5" || type[1] == "0") {
    //     if (!(event.which == 48)) {
    //     //  event.preventDefault();
    //     }
    //   }
    //   if (type[1] == "2" || type[1] == "7") {
    //     if (!(event.which == 53)) {
    //     //  event.preventDefault();
    //     }
    //   }
    // }
    let val = text.split(".");
    if (text.length > 4) {
      event.preventDefault();
    }
  }
}
